/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Copy: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M19.2041 7.01074C20.2128 7.11301 21 7.96436 21 9V20C21 21.1046 20.1046 22 19 22H10C8.96435 22 8.113 21.2128 8.01074 20.2041L8 20V9C8.00001 7.89544 8.89544 7 10 7H19L19.2041 7.01074ZM10 20H19V9H10V20ZM15.1025 2.00488C15.6067 2.05621 16 2.48232 16 3C16 3.51768 15.6067 3.94379 15.1025 3.99512L15 4H5V16L4.99512 16.1025C4.94378 16.6067 4.51767 17 4 17C3.48233 17 3.05622 16.6067 3.00488 16.1025L3 16V4C3 2.89543 3.89543 2 5 2H15L15.1025 2.00488Z'
      fill='currentColor'
    />
  </React.Fragment>
)
